const signatureScale = 1.05;
export const signatureWidth = 430 * signatureScale;
export const signatureHeight = 100 * signatureScale;
export const marginForSignature = 100 * signatureScale;
